module.exports = __webpack_public_path__ + "static/media/change_status_club_1.53efde56.png";